export default __webpack_public_path__ + "img/file.1219c458.svg";